export const REGEX_EMAIL = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
export const REGEX_USERNAME = /^(?=.{4,20}$)(?:[a-zA-Z\d]+(?:(?:\.|-|_)[a-zA-Z\d])*)+$/;
export const REGEX_USERNAME_IGNORE_COUNT = /^(?:[a-zA-Z\d]+(?:(?:\.|-|_)[a-zA-Z\d])*)+$/;
export const REGEX_PHONE_NUMBER = /^09\d{9}$/;
export const ASSCI_REGEX = /^[\s\w\d\x21-\x2f\x3a-\x40\x5b-\x60\x7b-\x7e]*$/;
export const UPDATE_VERSION = /^v(\d|\.)+v$/;

export const email = (value: string) => {
  return value && REGEX_EMAIL.test(value);
}

export const username = (value: string, ignoreCount: boolean = false) => {
  if (ignoreCount) {
    return value && REGEX_USERNAME_IGNORE_COUNT.test(value);
  }
  return value && REGEX_USERNAME.test(value);
}

export const phoneNumber = (value: string) => {
  return value && REGEX_PHONE_NUMBER.test(value);
}

export const english = (value: string) => {
  return value && ASSCI_REGEX.test(value);
}

export const updateVersion = (value: string) => {
  return value && UPDATE_VERSION.test(value);
}

export default {
  REGEX_EMAIL, REGEX_USERNAME, REGEX_PHONE_NUMBER,
  email, username, phoneNumber, english
};
